import React from "react";
import { DialogContent } from "@mui/material";
import { Modal } from "components/haven-design";
import { DialogActions } from "components/haven-design/modal/dialog";
import { Button } from "components/haven-design/buttons";
import { useSnackbar } from "components/haven-design/snackbar";
import { useResetPasswordEmail } from "pages/login/actions";
import { getUserLoginData_user as User } from "types/gql-types";
import styles from "../actions.module.css";

type Props = {
  currentInterestName: string;
  isOpen: boolean;
  user: User;
  onRequestClose: () => void;
  onCancel: () => void;
}

const formatPhoneNumber = (phone: string): string => phone
  .replace("+1", "")
  .replace(/\D/g, "")
  .replace(/^0/, "")
  .replace(
    /^(?<areaCode>\d\d\d)(?<prefix>\d{3})(?<lineNumber>\d{0,4}).*/,
    "($<areaCode>) $<prefix>-$<lineNumber>",
  );

const UserDetails: React.FC<{user: User}> = ({ user }) => (<>
  <div>
    <strong>User email: </strong>
    <span data-cy="reset-password-user-email">{user.email ?? "None"}</span>
  </div>
  <div>
    <strong>User phone: </strong>
    <span data-cy="reset-password-user-phone">{user.phone ? formatPhoneNumber(user.phone) : "None"}</span>
  </div>
</>);

type ResetButtonProps = {
  disabled?: boolean;
  onResetPassword: () => void
}
const ResetButton: React.FC<ResetButtonProps> =
  ({ disabled = false, onResetPassword }: ResetButtonProps) => (
    <Button
      form="request-forms"
      type="submit"
      className={styles.confirmationButton}
      color="primary"
      size="S"
      disabled={disabled}
      onClick={onResetPassword}
    >
      Reset Password
    </Button>
  );

const ResetPasswordFormModal: React.FC<Props> = ({
  currentInterestName,
  isOpen,
  onRequestClose,
  user,
}) => {
  const { openSnackbar } = useSnackbar();
  const resetPasswordEmail = useResetPasswordEmail();

  if (user.email === null) return null;
  const { email } = user;

  const resetPassword = () =>
    resetPasswordEmail(email, openSnackbar)
      .then(onRequestClose);

  return (
    <Modal
      title={`Reset password for ${currentInterestName}`}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <DialogContent><UserDetails user={user}/></DialogContent>

      <DialogActions>
        <Button
          className={styles.confirmationButton}
          color="secondary"
          size="S"
          onClick={onRequestClose}
        >
          Cancel
        </Button>
        <ResetButton onResetPassword={resetPassword} />
      </DialogActions>
    </Modal>
  );
};

export default ResetPasswordFormModal;

